import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { TrailheadInView } from '../types/Trailhead';

export type TrailheadUiState = {
  draftAdjustedLocation: { lat: number; lng: number } | undefined;
  hoveredConnectedTrailId: number | undefined;
  hoveredTrailheadId: TrailheadInView['id'] | undefined;
  isConnectedTrailsTabActive: boolean;
  isDetailsEditing: boolean;
  showConnectedTrailRouteLines: boolean;
  trailheadsInView: TrailheadInView[];
};

export const initialState: TrailheadUiState = {
  draftAdjustedLocation: undefined,
  hoveredConnectedTrailId: undefined,
  hoveredTrailheadId: undefined,
  isConnectedTrailsTabActive: false,
  isDetailsEditing: false,
  showConnectedTrailRouteLines: true,
  trailheadsInView: []
};

const trailheadSlice = createSlice({
  name: 'trailhead',
  initialState,
  reducers: {
    clearDetailsDraft: state => {
      state.draftAdjustedLocation = undefined;
      state.isDetailsEditing = false;
    },
    setConnectedTrailsTabActive: (state, action: PayloadAction<boolean>) => {
      state.isConnectedTrailsTabActive = action.payload;
      if (!action.payload) {
        state.hoveredConnectedTrailId = undefined;
      }
    },
    setDetailsEditing: (state, action: PayloadAction<boolean>) => {
      state.isDetailsEditing = action.payload;
    },
    setDraftAdjustedLocation: (state, action: PayloadAction<{ lat: number; lng: number }>) => {
      state.draftAdjustedLocation = action.payload;
    },
    setHoveredConnectedTrailId: (state, action: PayloadAction<number | undefined>) => {
      state.hoveredConnectedTrailId = action.payload;
    },
    setHoveredTrailheadId: (state, action: PayloadAction<TrailheadInView['id'] | undefined>) => {
      state.hoveredTrailheadId = action.payload;
    },
    setShowConnectedTrailRouteLines: (state, action: PayloadAction<boolean>) => {
      state.showConnectedTrailRouteLines = action.payload;
    },
    setTrailheadsInView: (state, action: PayloadAction<TrailheadInView[]>) => {
      state.trailheadsInView = action.payload;
    }
  }
});

export const {
  clearDetailsDraft,
  setConnectedTrailsTabActive,
  setDetailsEditing,
  setDraftAdjustedLocation,
  setHoveredConnectedTrailId,
  setHoveredTrailheadId,
  setShowConnectedTrailRouteLines,
  setTrailheadsInView
} = trailheadSlice.actions;
export default trailheadSlice.reducer;
